import ChatRoomHeader from "./ChatRoomHeader";
import Messages from "./Messages";
import SendMessage from "./SendMessage";
import UserPresence from "./UserPresence";

const CommonChatRoom = () => {
  return (
    <>
      <UserPresence />
      <div className="chat-area">
        <ChatRoomHeader />
        <Messages />
        <SendMessage />
      </div>
    </>
  );
};

export default CommonChatRoom;
